export default [
  {
    path: '/chatbot',
    name: 'chatbot',
    component: () => import('@/views/modules/skeleton/chatbot/Chatbot.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'AI Co-Teacher',
          active: true,
          // back: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/show-chatbot/:id',
    name: 'show_chatbot',
    component: () => import('@/views/modules/skeleton/chatbot/ChatbotDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'AI Co-Teacher Details',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  // {
  //   path: "/add-chatbot",
  //   name: "create_chatbot",
  //   component: () =>
  //     import("@/views/modules/skeleton/chatbot/Createchatbot.vue"),
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Add chatbot',
  //         back: true,
  //         active: true,
  //         redirectIfLoggedIn: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: "/edit-chatbot/:id",
  //   name: "edit_chatbot",
  //   component: () =>
  //     import("@/views/modules/skeleton/chatbot/Createchatbot.vue"),
  //   meta: {
  //     breadcrumb: [
  //       {
  //         text: 'Edit chatbot',
  //         back: true,
  //         active: true,
  //         redirectIfLoggedIn: true,
  //       },
  //     ],
  //   },
  // },
]
